export const MILLISECONDS_IN_MIN = 60_000;

export const HOUR_MIDNIGHT = '00';
export const HOUR_MIDNIGHT_ALTERNATE = '24';
